import { useState, useEffect } from 'react';
import List from '@mui/material/List';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import AddLinkIcon from '@mui/icons-material/AddLink';
//import VaccinesIcon from '@mui/icons-material/Vaccines';
import PsychologyIcon from '@mui/icons-material/Psychology';
//import SplitscreenIcon from '@mui/icons-material/Splitscreen';
//import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
//import PictureInPictureOutlinedIcon from '@mui/icons-material/PictureInPictureOutlined';
import MedicationLiquidIcon from '@mui/icons-material/MedicationLiquid';
//import HomeMaxIcon from '@mui/icons-material/HomeMax';
//import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import StartIcon from '@mui/icons-material/Start';
import PersonIcon from '@mui/icons-material/Person';
import EmergencyShareIcon from '@mui/icons-material/EmergencyShare';
import BiotechIcon from '@mui/icons-material/Biotech';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import NightlifeIcon from '@mui/icons-material/Nightlife';
import BabyChangingStationIcon from '@mui/icons-material/BabyChangingStation';
import MemoryIcon from '@mui/icons-material/Memory';
//import TimelineIcon from '@mui/icons-material/Timeline';
//import GridViewIcon from '@mui/icons-material/GridView';
import SearchIcon from '@mui/icons-material/Search';
import LinkIcon from '@mui/icons-material/Link';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
//import BloodtypeIcon from '@mui/icons-material/Bloodtype';
//import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { SidebarItem } from './SidebarItem';
import { SidebarChapter } from './SidebarChapter';
import { HandCoins, CircleOff, ShieldHalf, Vegan, Goal, Tablets, HeartPulse, ShoppingCart, CircleSmall, Microscope, BrickWallShield, Apple, Brain, Bone, CalendarRange, ChartNoAxesCombined, CircleGauge, LayoutDashboard, Route, Upload, KeyRound, House, Fish, MessageSquare, ListChecks, Stethoscope, Grid3x3 } from 'lucide-react';
import { useTranslation } from '../../language';
import { useAuth } from '../../provider';
import * as api from '../../Auth/auth';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';


export default function SidebarList() {

const { t } = useTranslation();
const { state } = useAuth();
const theme = useTheme();
const isMale = state.user?.gender === "M";
const chapterAccent = theme.palette.primary.light;

const [omegaPurchased, setOmegaPurchased] = useState(false);

useEffect(() => {
  api.getAddonPurchased('omega')
    .then(res => setOmegaPurchased(!!res?.purchased))
    .catch(() => setOmegaPurchased(false));
}, []);

return (

<>

<List component="nav" disablePadding data-tour="sidebar-list" sx={{mt: '2em',width: '100%', maxWidth: 340,}} >


<SidebarChapter number={1} accentColor={chapterAccent} chapter = {t('nav_chapter_health_intelligence')}  />
<SidebarItem drawerlink = {"/CockpitWelcome"} itemicon = { <LayoutDashboard  size={16} /> } draweritem = {t('nav_health_summary_cockpit')}  />
<SidebarItem drawerlink = {"/MechanismsWelcome"} itemicon = { <Grid3x3  size={16} /> } draweritem = {t('nav_12_mechanisms')}  />
<SidebarItem drawerlink = {"/RecommendationsWelcome"} itemicon = { <ListChecks  size={16} /> } draweritem = {t('hc_section_02_title')}  />
<SidebarItem drawerlink = {"/DoctorNotesWelcome"} itemicon = { <Stethoscope  size={16} /> } draweritem = {t('hc_section_03_title')}  />
<SidebarItem drawerlink = {"/BioAgeWelcome"} itemicon = { <HandCoins  size={16} /> } draweritem = {t('nav_biological_age')}  />

{/* Zero-height anchor for the mobile tour step-2 tooltip — lets the arrow
    point at a fixed spot mid-list instead of the whole (very tall) list. */}
<Box data-tour="sidebar-list-anchor" />

<SidebarChapter number={2} accentColor={chapterAccent} chapter = {t('nav_chapter_test_results')}  />
<SidebarItem drawerlink = {"/BloodtestsWelcome"} itemicon = {<Microscope size={16} />} draweritem = {t('nav_bloodtests')}  />
{/*
<SidebarItem drawerlink = {"/BloodCoreWelcome"} itemicon = {<BrickWallShield size={16} color="lightGreen" />} draweritem = {t('nav_core_health')}  />
<SidebarItem drawerlink = {"/BloodArterioWelcome"} itemicon = {<Route size={16} color="lightGreen" />} draweritem = {t('nav_arteriosclerosis_prevention')}  />
<SidebarItem drawerlink = {"/BloodOmegaWelcome"} itemicon = {<Apple size={16} color="lightGreen" />} draweritem = {t('nav_marker_omega_lifestyle')}  />

<SidebarItem drawerlink = {"/BloodBonesWelcome"} itemicon = {<Bone size={16} color="lightGreen" />} draweritem = {t('nav_bones_health')}  />
<SidebarItem drawerlink = {"/BloodVitaminsWelcome"} itemicon = {<Vegan size={16} color="lightGreen" />} draweritem = {t('nav_vitamins_nutrients')}  />
<SidebarItem drawerlink = {"/BloodThyroidWelcome"} itemicon = {<ShieldHalf size={16} color="lightGreen" />} draweritem = {t('nav_thyroid_health')}  />

<SidebarItem drawerlink = {"/BloodPsaWelcome"} itemicon = {<CircleOff size={16} color="lightGreen" />} draweritem = {t('nav_male_prostate_health_psa')}  />
<SidebarItem drawerlink = {"/StoolWelcome"} itemicon = {<CircleSmall size={16} color="lightBlue" />} draweritem = {t('nav_stool_cancer_test_fob')}  />

*/}

<Box data-tour="nav-addons">
<SidebarItem drawerlink = {"/BloodHormonesWelcome"} itemicon = {<Brain size={16} />} draweritem = {t('nav_hormones_balance')} disabled={isMale} />
<SidebarItem drawerlink = {"/OmegaDetails"} itemicon = { <Fish  size={16} /> } draweritem = {t('nav_omega_details')} disabled={!omegaPurchased} />
<SidebarItem drawerlink = {"/GutMicrobiomeWelcome"} itemicon = {<ChartNoAxesCombined size={16} />} draweritem = {t('nav_gut_microbiome_report')}  />
</Box>

<SidebarItem drawerlink = {"/BloodFertilityWelcome"} itemicon = {<CircleGauge size={16} />} draweritem = {t('nav_female_fertility_amh')} disabled={isMale} />




{/*
<SidebarItem drawerlink = {"/BloodAddonsWelcome"} itemicon = {<Brain size={16} color="lightGreen" />} draweritem = {"Marker Addon Packs"}  />
<SidebarItem drawerlink = {"/LiverPancreasWelcome"} itemicon = {<CircleSmall size={16} color="lightGreen" />} draweritem = {"Liver & Pancreas"}  />
<SidebarItem drawerlink = {"/KidneyWelcome"} itemicon = {<CircleGauge size={16} color="lightGreen" />} draweritem = {"Kidney & Electrolytes"}  />
<SidebarItem drawerlink = {"/ImmunityWelcome"} itemicon = {<BrickWallShield size={16} color="lightGreen" />} draweritem = {"Immunity & Hematology"}  />
<SidebarItem drawerlink = {"/VitaminsWelcome"} itemicon = {<Apple size={16} color="lightGreen" />} draweritem = {"Nutrients & Vitamins"}  />
<SidebarItem drawerlink = {"/HormonesWelcome"} itemicon = {<Brain size={16} color="lightGreen" />} draweritem = {"Hormones"}  />
<SidebarItem drawerlink = {"/BonesWelcome"} itemicon = {<Bone size={16} color="lightGreen" />} draweritem = {"Bones"}  />
<SidebarItem drawerlink = {"/LabfinderWelcome"} itemicon = {<Goal size={16} color="lightBlue" />} draweritem = {"Lab Finder"}  />
*/}


<SidebarChapter number={3} accentColor={chapterAccent} chapter = {t('nav_chapter_utilities_apps')}  />
<SidebarItem drawerlink = {"/VitalsWelcome"} itemicon = {<HeartPulse size={16} />} draweritem = {t('nav_health_essentials')}  />

<SidebarItem drawerlink = {"/PeriodTrackerWelcome"} itemicon = {<CalendarRange size={16}  />} draweritem = {t('nav_female_cycle_tracker')} disabled={isMale} />
<SidebarItem drawerlink = {"/MedicationWelcome"} itemicon = { <Tablets size={16} /> } draweritem = {t('nav_your_medication_list')}  />
<SidebarItem drawerlink = {"/UserLabreportsWelcome"} itemicon = { <Upload size={16} /> } draweritem = {t('lab_nav_item')}  />
{/*
<SidebarItem drawerlink = {"/GutKitWelcome"} itemicon = {<Goal size={16} color="lightGreen" />} draweritem = {t('nav_kit_activation_stool_sample')}  />
*/}


{/* Counselling - Booking a Physician
<SidebarChapter chapter = {"DOCTOR COUNSELING"}  />

<SidebarItem drawerlink = {"/Doctor"} itemicon = {<MedicalInformationIcon /> } draweritem = {"Book Counselling"}  />
<SidebarItem drawerlink = {"/Meeting"} itemicon = { <CompareArrowsIcon /> } draweritem = {"Video Conferencing"}  />
*/}

{/* USER ADMIN & BILLING */}
<SidebarChapter number={4} accentColor={chapterAccent} chapter = {t('nav_chapter_account')}  />

<SidebarItem drawerlink = {"/LabVisitsWelcome"} itemicon = { <Microscope size={16} /> } draweritem = {t('nav_your_labvisits')}  />
<SidebarItem drawerlink = {"/SubscriptionWelcome"} itemicon = { <SubscriptionsIcon /> } draweritem = {t('nav_your_subscription')}  />
<SidebarItem drawerlink = {"/AddOnsWelcome"} itemicon = { <ShoppingCart size={16} /> } draweritem = {t('nav_your_addon_purchases')}  />
<SidebarItem drawerlink = {"/QuestionnaireWelcome"} itemicon = {<Microscope size={16} />} draweritem = {t('nav_your_questionnaire_responses')}  />
<SidebarItem drawerlink = {"/FeedbackWelcome"} itemicon = { <MessageSquare size={16} /> } draweritem = {t('nav_feedback')}  />
<SidebarItem drawerlink = {"/UserAdminWelcome"} itemicon = { <PersonIcon /> } draweritem = {t('nav_your_personal_data')}  />
<SidebarItem drawerlink = {"/PasswordChangeDashboard"} itemicon = { <KeyRound size={16} /> } draweritem = {t('nav_your_change_password')}  />
<SidebarItem drawerlink = {"/Welcome"} itemicon = { <House  size={16} /> } draweritem = {t('nav_welcome')}  />

{/*

<SidebarChapter chapter = {"AGING / LONGEVITY"}  />
<SidebarItem drawerlink = {"/EpigeneticsWelcome"} itemicon = {<HourglassEmptyIcon />} draweritem = {"Epigenetic Analysis"}  />
<SidebarItem drawerlink = {"/LongevityWelcome"} itemicon = {<AccessibilityIcon />} draweritem = {"Longevity Genetics"}  />

<SidebarChapter chapter = {"GENETICS"}  />
<SidebarItem drawerlink = {"/WatchlistWelcome"} itemicon = {<FilterListOutlinedIcon />} draweritem = {"Personal Watchlist"}  />
<SidebarItem drawerlink = {"/GeneticsWelcome"} itemicon = {<EmergencyShareIcon />} draweritem = {"Hereditary Disease Risk"}  />
<SidebarItem drawerlink = {"/CancerRiskWelcome"} itemicon = {<BiotechIcon />} draweritem = {"Hereditary Cancer Risk"}  />
<SidebarItem drawerlink = {"/NewbornWelcome"} itemicon = {<BabyChangingStationIcon />} draweritem = {"Newborn Screening"}  />
<SidebarItem drawerlink = {"/SearchWelcome"} itemicon = {<SearchIcon />} draweritem = {"Explore & Visualize"}  />
<SidebarItem drawerlink = {"/ArchiveWelcome"} itemicon = { <StartIcon /> } draweritem = {"Secure Genome Archive"}  />

PHARMACOGENETICS
<SidebarChapter chapter = {"PHARMACOGENETICS"}  />
<SidebarItem drawerlink = {"/Pgx"} itemicon = {<LinkIcon />} draweritem = {"PGx Genotypes"}  />
<SidebarItem drawerlink = {"/Drugs"} itemicon = {<MedicationLiquidIcon />} draweritem = {"Medication Guide"}  />


STOOL
<SidebarItem drawerlink = {"/CalWelcome"} itemicon = {<Route size={16} color="lightGreen" />} draweritem = {"Stool Inflammation Test"}  />

<SidebarItem drawerlink = {"/MouthMicrobiomeWelcome"} itemicon = {<NightlifeIcon />} draweritem = {"Mouth Microbiome Analysis"}  />

GENERAL HEALTH RECORDS
<SidebarChapter chapter = {"HEALTH RECORDS"}  />
<SidebarItem drawerlink = {"/RecordsWelcome"} itemicon = { <AddLinkIcon  /> } draweritem = {"Health Records"}  />
<SidebarItem drawerlink = {"/VaccsWelcome"} itemicon = { <AddLinkIcon  /> } draweritem = {"Vaccination History"}  />

ONBOARDING HELPERS
<SidebarItem drawerlink = {"/OnboardingWelcome"} itemicon = { <SubscriptionsIcon /> } draweritem = {"OnboardingWelcome"}  />
<SidebarItem drawerlink = {"/OnboardingData"} itemicon = { <SubscriptionsIcon /> } draweritem = {"OnboardingData"}  />
<SidebarItem drawerlink = {"/WaitingResults"} itemicon = { <SubscriptionsIcon /> } draweritem = {"WaitingResults"}  />

<SidebarItem drawerlink = {"/QuestionnaireWelcome"} itemicon = {<Microscope size={16} color="lightBlue" />} draweritem = {"Questionnaire"}  />


<SidebarChapter chapter = {"BODY SYSTEMS"}  />
<SidebarItem drawerlink = {"/CVDWelcome"} itemicon = {<HeartBrokenIcon />} draweritem = {"Cardiovascular Health"}  />
<SidebarItem drawerlink = {"/NeuroWelcome"} itemicon = { <PsychologyIcon  />} draweritem = {"Neurology Health"}  />

<SidebarItem drawerlink = {"/SkinWelcome"} itemicon = { <SplitscreenIcon fontSize="small" />} draweritem = {"Skin Health"}  />
<SidebarItem drawerlink = {"/EyesWelcome"} itemicon = {<VisibilityOutlinedIcon />} draweritem = {"Eyes Health"}  />
<SidebarItem drawerlink = {"/ImmuneWelcome"} itemicon = {<VaccinesIcon  />} draweritem = {"Immune System Health"}  />


OLD COLCKPIT
<SidebarItem drawerlink = {"/MainWelcome"} itemicon = { <PictureInPictureOutlinedIcon /> } draweritem = {"Old Cockpit"}  />
*/}

</List>


</>
)
}
